import { Card, CardContent } from "@components/ui/Card";

const SummaryCard = ({
  label,
  value,
  icon: Icon,
  iconBg,
  iconColor,
  textColor,
}) => {
  return (
    <Card className="overflow-hidden !rounded-3xl !border !border-gray-100 !shadow-none">
      <CardContent className="p-4">
        <div className="flex flex-col">
          <div className="flex justify-between items-center w-full">
            <div className={`text-[40px] ${textColor} mb-1 font-semibold`}>{value}</div>
            <div
              className={`w-10 h-10 ${iconBg} rounded-full flex items-center justify-center mb-2`}
            >
              <Icon className={`w-6 h-6 ${iconColor}`} />
            </div>
          </div>

          <div className="text-gray-600 leading-tight">{label}</div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;
